import Axios from "axios";
import { baseUrl } from "../config/base-url";

export function getCategories() {
  return Axios({
    url: `${baseUrl()}/categories`,
    method: "GET",
  });
}
